import {
  REPORT_FWPROGRESS_FETCH_SUCCESS,
  REPORT_FWPROGRESS_FETCH_RESET,
  REPORT_QCDATA_FETCH_SUCCESS,
  REPORT_QCDATA_FETCH_RESET,
  REPORT_SUMMARY_OVERVIEW_FETCH_SUCCESS,
  REPORT_SUMMARY_OVERVIEW_FETCH_RESET,
  REPORT_SUMMARY_FACTOR_FETCH_SUCCESS,
  REPORT_SUMMARY_FACTOR_FETCH_RESET,
  REPORT_SUMMARY_CARMODEL_FETCH_SUCCESS,
  REPORT_SUMMARY_CARMODEL_FETCH_RESET,
  REPORT_LATEST_FETCH_SUCCESS,
  REPORT_LATEST_FETCH_RESET,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_SUCCESS,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_RESET,
  REPORT_CUSTOMER_VOICE_FETCH_SUCCESS,
  REPORT_CUSTOMER_VOICE_FETCH_RESET,
  REPORT_RANKING_FETCH_SUCCESS,
  REPORT_RANKING_FETCH_RESET,
} from '../actions/types';

const INIT_STATE = {
  reportFwProgress: {},
  reportQcData: {},
  reportSummaryOverview: {},
  reportSummaryOverviewDefault: {},
  reportSummaryFactor: {},
  reportSummaryCarModel: {},
  reportLatest: {},
  reportCustomerVoice: {},
  reportRanking: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REPORT_FWPROGRESS_FETCH_SUCCESS:
      return {
        ...state,
        reportFwProgress: action.payload,
      };
    case REPORT_FWPROGRESS_FETCH_RESET:
      return {
        ...state,
        reportFwProgress: {},
      };
    case REPORT_QCDATA_FETCH_SUCCESS:
      return {
        ...state,
        reportQcData: action.payload,
      };
    case REPORT_QCDATA_FETCH_RESET:
      return {
        ...state,
        reportQcData: {},
      };
    case REPORT_SUMMARY_OVERVIEW_FETCH_SUCCESS:
      return {
        ...state,
        reportSummaryOverview: action.payload,
      };
    case REPORT_SUMMARY_OVERVIEW_FETCH_RESET:
      return {
        ...state,
        reportSummaryOverview: {},
      };
    case REPORT_SUMMARY_FACTOR_FETCH_SUCCESS:
      return {
        ...state,
        reportSummaryFactor: action.payload,
      };
    case REPORT_SUMMARY_FACTOR_FETCH_RESET:
      return {
        ...state,
        reportSummaryFactor: {},
      };
    case REPORT_SUMMARY_CARMODEL_FETCH_SUCCESS:
      return {
        ...state,
        reportSummaryCarModel: action.payload,
      };
    case REPORT_SUMMARY_CARMODEL_FETCH_RESET:
      return {
        ...state,
        reportSummaryCarModel: {},
      };
    case REPORT_LATEST_FETCH_SUCCESS:
      return {
        ...state,
        reportLatest: action.payload,
      };
    case REPORT_LATEST_FETCH_RESET:
      return {
        ...state,
        reportLatest: {},
      };
    case REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_SUCCESS:
      return {
        ...state,
        reportSummaryOverviewDefault: action.payload,
      };
    case REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_RESET:
      return {
        ...state,
        reportSummaryOverviewDefault: {},
      };
    case REPORT_CUSTOMER_VOICE_FETCH_SUCCESS:
      return {
        ...state,
        reportCustomerVoice: action.payload,
      };
    case REPORT_CUSTOMER_VOICE_FETCH_RESET:
      return {
        ...state,
        reportCustomerVoice: {},
      };
    case REPORT_RANKING_FETCH_SUCCESS:
      return {
        ...state,
        reportRanking: action.payload,
      };
    case REPORT_RANKING_FETCH_RESET:
      return {
        ...state,
        reportRanking: {},
      };
    default:
      return state;
  }
};
